import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { parse, format, isValid } from "date-fns";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatTimestamp(dateInput: string | Date): string {
  try {
    let date = new Date(dateInput);

    if (!isValid(date)) {
      date = parse(dateInput as string, "dd.MM.yyyy HH:mm:ss", new Date());
    }

    if (!isValid(date)) {
      const midnight = new Date();
      midnight.setHours(0, 0, 0, 0);
      date = parse(dateInput as string, "dd.MM.yyyy", midnight);
    }

    if (!isValid(date)) {
      return dateInput.toString();
    }

    const isMidnight = date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0;

    if (isMidnight) {
      return format(date, "MMM d, yyyy");
    }

    return format(date, "HH:mm , MMM d, yyyy");
  } catch (error) {
    console.error("Error formatting timestamp:", error);
    return dateInput.toString();
  }
}
